import EdoTooltips from "./EdoTooltips";

export default EdoTooltips;
